import { APP_ENV } from 'Data/constants'

export function isDevelopment() {
  return APP_ENV === 'development'
}
